import { render, staticRenderFns } from "./golf_admin.vue?vue&type=template&id=0f015dd3&scoped=true"
import script from "./golf_admin.vue?vue&type=script&lang=js"
export * from "./golf_admin.vue?vue&type=script&lang=js"
import style0 from "./golf_admin.vue?vue&type=style&index=0&id=0f015dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f015dd3",
  null
  
)

export default component.exports